import React from 'react'
import { Link } from "react-router-dom";
import {routes} from '../../config/routes'

import { Trans } from "react-i18next";

const Sidebar = ({toggle,current_user}) => {

    
    return (
	<nav className={`sidebar ${toggle===true ? 'toggled' : ''}`}>
	    <div className="sidebar-content">
		<Link className="sidebar-brand" to="/">	<img src="/logo.svg"  alt="logo" className="img-fluid" width="132"  height="132" 	/></Link>
		<ul className="sidebar-nav">
		    {routes.filter((r) => r.sidebar && r.roles.includes(current_user.info.user_type)).map((r) => (
			<li key={r.name} className="sidebar-item">
			    <Link to={r.url} className="sidebar-link" >
				<div><Trans>menu.{r.name}</Trans></div>
			    </Link>
			</li>
		    ))}
		</ul>
	    </div>
	</nav>
    )}


export default Sidebar
